module.exports = __webpack_public_path__ + "files/a323c7221b9fcd4117d8a5d55c2b31ca.png";